import React from 'react';
import { useSelector } from 'react-redux';
import { getManuals } from 'features/product-info';
import { FileTextIcon } from '@fronton/icons-react';
import { LinkButton, Typography } from 'fronton-react';
import { cx } from 'linaria';
import { useTranslation } from 'react-i18next';
import { pdpSectionStyle } from 'common/components/page-section';
import { useBreakpoints } from 'common/hooks';
import { isURL } from 'entries/server/utils';
import {
  labelLinkButtonStyle,
  manualsInnerWrap,
  manualsOuterWrap,
  manualWrap,
  sizeLinkButtonStyle,
  textWrap,
  EmptyBlock,
} from './manuals.styles';
import { bytesToMegabytes } from '../utils/bytes-to-megabytes';

export const DATA_QA_MANUAL_FILESIZE = 'manual-filesize';
export const DATA_QA_MANUAL_TEXT_WRAP = 'manual-text-wrap';
export const DATA_QA_MANUALS_WRAP = 'manuals-wrap';
export const DATA_QA_MANUALS = 'manuals';
export const DATA_QA_MANUALS_EMPTY_BLOCK = 'manuals-empty-block';

export const Manuals = () => {
  const manuals = useSelector(getManuals);
  const allUrlsInvalid = manuals?.every(({ url }) => !isURL(url ?? ''));
  const { t } = useTranslation();
  const { mobile } = useBreakpoints() || {
    mobile: false,
  };

  if (!manuals || !manuals.length || allUrlsInvalid) {
    return <EmptyBlock data-qa={DATA_QA_MANUALS_EMPTY_BLOCK} />;
  }

  return (
    <div className={cx(pdpSectionStyle, manualsOuterWrap)} data-qa={DATA_QA_MANUALS_WRAP}>
      <div className={manualsInnerWrap} data-qa={DATA_QA_MANUALS}>
        {manuals.map(({ url, filesize }, idx) => {
          if (!isURL(url ?? '')) return;
          const filesizeMb = filesize ? `${bytesToMegabytes(filesize)} MB` : null;
          return (
            <LinkButton className={manualWrap} key={url} href={url ?? ''} target="_blank">
              <FileTextIcon type="fill" size="space-500" color="text-minor" />
              <div className={textWrap} data-qa={DATA_QA_MANUAL_TEXT_WRAP}>
                <Typography
                  className={labelLinkButtonStyle}
                  size="body_accent"
                  variant="s"
                  color="text-primary"
                >
                  {manuals.length > 1
                    ? `${t('product-info.manuals.manual')} ${idx + 1}`
                    : t('product-info.manuals.manual')}
                </Typography>
                {filesizeMb && !mobile && (
                  <Typography
                    className={sizeLinkButtonStyle}
                    variant="caption"
                    color="text-secondary"
                    data-qa={DATA_QA_MANUAL_FILESIZE}
                  >
                    {filesizeMb}
                  </Typography>
                )}
              </div>
            </LinkButton>
          );
        })}
      </div>
    </div>
  );
};
